import { render, staticRenderFns } from "./AgentActivitiesReportCard.vue?vue&type=template&id=72b8f52e&scoped=true"
import script from "./AgentActivitiesReportCard.vue?vue&type=script&lang=js"
export * from "./AgentActivitiesReportCard.vue?vue&type=script&lang=js"
import style0 from "./AgentActivitiesReportCard.vue?vue&type=style&index=0&id=72b8f52e&prod&lang=scss"
import style1 from "./AgentActivitiesReportCard.vue?vue&type=style&index=1&id=72b8f52e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b8f52e",
  null
  
)

export default component.exports